import { Router } from 'vue-router'

import { InternalAPI } from '@/shared/apis/messages'
import { IEthProvider } from '@/popup/utils/ethProvider'

type SendMessageResponse = <T extends keyof InternalAPI>(parameters: {
  method: T
  payload: InternalAPI[T]['payload']
}) => Promise<InternalAPI[T]['response']>

let _ethProvider: IEthProvider
let _sendMessage: SendMessageResponse
let _router: Router

const initGlobals = (
  ethProvider: IEthProvider,
  sendMessage: SendMessageResponse,
  router: Router
) => {
  _ethProvider = ethProvider
  _sendMessage = sendMessage
  _router = router
}

export const useGlobals = (): {
  init: (
    ethProvider: IEthProvider,
    sendMessage: SendMessageResponse,
    router: Router
  ) => void
  sendMessage: SendMessageResponse
  ethProvider: IEthProvider
  router: Router
} => {
  return {
    init: initGlobals,
    ethProvider: _ethProvider,
    sendMessage: _sendMessage,
    router: _router,
  }
}
